import request from '@aned/request';
import { removeApiPrefix } from '@/utils/requestPath';

// Torna share: Br2jl3XG
// 分拨收/派时效标准配置 - 分页查询
export const transferStandardPageApi = '/api/cityToCity/dispatchStandardConfig/selectPage';
// 分拨收/派时效标准配置 - 批量更新
export const transferStandardBatchUpdateApi = '/api/cityToCity/dispatchStandardConfig/batchUpdate';
// 分拨收/派时效标准配置 - 单条更新
export const transferStandardUpdateApi = '/api/cityToCity/dispatchStandardConfig/update';
// 分拨收/派时效标准配置 - 导出
export const transferStandardExportApi = '/api/cityToCity/dispatchStandardConfig/export';
// 分拨收/派时效标准配置 - 导入
export const transferStandardImportApi = '/api/cityToCity/dispatchStandardConfig/importData';
// 分拨收/派时效标准配置 - 删除
export const transferStandardDeleteByCenterCodeApi =
  '/api/cityToCity/dispatchStandardConfig/deleteByCenterCode';
// 分拨收/派时效标准配置 - 获取推送配置
export const transferStandardGetConfigApi = '/api/cityToCity/dispatchStandardConfig/getConfig';
// 分拨收/派时效标准配置 - 保存推送配置
export const transferStandardSaveApi = '/api/cityToCity/dispatchStandardConfig/saveConfig';
// 分拨收/派时效标准配置 - 立即执行定时任务
export const transferStandardExecuteApi = '/api/cityToCity/dispatchStandardConfig/executeData';
// 用户模糊查询
export const userSelectByKeyApi = '/api/user/selectByKey';
export const localUserSelectByKeyApi = '/LOCAL_API/tdcs/mdp-user/api/user/selectByKey';

export const transferStandardPagePath = removeApiPrefix(transferStandardPageApi);
export const transferStandardBatchUpdatePath = removeApiPrefix(transferStandardBatchUpdateApi);
export const transferStandardUpdatePath = removeApiPrefix(transferStandardUpdateApi);
export const transferStandardExportPath = removeApiPrefix(transferStandardExportApi);
export const transferStandardImportPath = removeApiPrefix(transferStandardImportApi);
export const transferStandardDeleteByCenterCodePath = removeApiPrefix(
  transferStandardDeleteByCenterCodeApi,
);
export const transferStandardGetConfigPath = removeApiPrefix(transferStandardGetConfigApi);
export const transferStandardSavePath = removeApiPrefix(transferStandardSaveApi);
export const transferStandardExecutePath = removeApiPrefix(transferStandardExecuteApi);

// 分拨收/派时效标准配置 - 分页查询
export async function fetchTransferStandardPage(params) {
  return request(transferStandardPageApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 分拨收/派时效标准配置 - 导出
export async function fetchTransferStandardExport(params) {
  return request(transferStandardExportApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 分拨收/派时效标准配置 - 导入
export async function fetchTransferStandardImport(params) {
  return request(transferStandardImportApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 分拨收/派时效标准配置 - 批量更新
export async function fetchTransferStandardBatchUpdate(params) {
  return request(transferStandardBatchUpdateApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 分拨收/派时效标准配置 - 单条更新
export async function fetchTransferStandardUpdate(params) {
  return request(transferStandardUpdateApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 分拨收/派时效标准配置 - 删除
export async function fetchTransferStandardDeleteByCenterCode(params) {
  return request(transferStandardDeleteByCenterCodeApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 分拨收/派时效标准配置 - 获取推送配置
export async function fetchTransferStandardGetConfig(params) {
  return request(transferStandardGetConfigApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 分拨收/派时效标准配置 - 保存推送配置
export async function fetchTransferStandardSaveConfig(params) {
  return request(transferStandardSaveApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 分拨收/派时效标准配置 - 立即执行定时任务
export async function fetchTransferStandardExecute() {
  return request(transferStandardExecuteApi, {
    method: 'POST',
    reqType: 'json',
    module: 'basic',
  });
}

export async function fetchUserSelectByKey(params) {
  return request(
    process.env.NODE_ENV === 'development' ? localUserSelectByKeyApi : userSelectByKeyApi,
    {
      method: 'POST',
      body: params,
      reqType: 'format',
      ...(process.env.NODE_ENV === 'development' ? {} : { mergeModuleName: 'tdcs/mdp-user' }),
    },
  );
}
